import React from 'react';
import ModalImage from 'react-modal-image';
const galleryData = [
  {
    src: 'images/img/image_16.webp',
    srcLg: 'images/img/image_16.webp',
  },
  {
    src: 'images/img/image_36.webp',
    srcLg: 'images/img/image_36.webp',
  },
  {
    src: 'images/img/image_4.webp',
    srcLg: 'images/img/image_4.webp',
  },
  {
    src: 'images/img/image_41.webp',
    srcLg: 'images/img/image_41.webp',
  },
  {
    src: 'images/img/image_44.webp',
    srcLg: 'images/img/image_44.webp',
  },
];

export default function GalleryStyle2() {
  return (
    <div className="cs-grid_gallery_5 cs-lightgallery">
      {galleryData?.map((item, index) => (
        <div className="cs-grid_gallery_item" key={index}>
          <div className="cs-portfolio cs-style1 cs-lightbox_item cs-type2 rounded-0">
            <div className="cs-portfolio_hover" />
            <span className="cs-plus" />
            <div
              className="cs-portfolio_bg cs-bg"
              style={{ backgroundImage: `url("${item.src}")` }}
            >
              <ModalImage small={item.src} large={item.srcLg} alt="Gallery" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
